import { render, staticRenderFns } from "./ToggleFlyerOrientationButtonV2.vue?vue&type=template&id=33edf3ff&scoped=true&"
import script from "./ToggleFlyerOrientationButtonV2.vue?vue&type=script&lang=js&"
export * from "./ToggleFlyerOrientationButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./ToggleFlyerOrientationButtonV2.vue?vue&type=style&index=0&id=33edf3ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edf3ff",
  null
  
)

export default component.exports